var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wheel-home-game-wheel-information" }, [
    _c("div", { staticClass: "information" }, [
      _c(
        "div",
        {
          staticClass: "information__timer",
          class: { "is-hidden": _vm.gameStatus === _vm.GameStatus.STARTED },
        },
        [_vm._v(" " + _vm._s(_vm.timerValue) + " ")]
      ),
      _c(
        "div",
        {
          staticClass: "information__loader",
          class: { "is-hidden": _vm.gameStatus !== _vm.GameStatus.STARTED },
        },
        [
          !_vm.disableAnimations
            ? _c(
                "svg",
                {
                  attrs: {
                    width: "40",
                    height: "40",
                    viewBox: "0 0 40 40",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c(
                    "circle",
                    {
                      attrs: {
                        cx: "20",
                        cy: "20",
                        r: "15",
                        fill: "transparent",
                        stroke: "#fff",
                        "stroke-width": "4",
                      },
                    },
                    [
                      _c("animateTransform", {
                        attrs: {
                          attributeName: "transform",
                          type: "rotate",
                          from: "0 20 20",
                          to: "360 20 20",
                          begin: "0s",
                          dur: "5s",
                          repeatCount: "indefinite",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "information__status" }, [
        _vm._v(" " + _vm._s(_vm.timerSubtitle) + " "),
      ]),
      _c("div", { staticClass: "information__stats information__stats_bank" }, [
        _c("i", { staticClass: "icon icon_money-bold" }),
        _c("span", [_vm._v(_vm._s(_vm.formattedBank))]),
      ]),
      _c("div", { staticClass: "information__stats" }, [
        _c("i", { staticClass: "icon icon_users-bold" }),
        _c("span", [_vm._v(" " + _vm._s(_vm.formattedUsersCount) + " ")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }